export default [
  {
    path: '/',
    redirect: '/loading'
  },
  // {
  //   path: '/example', // 路径
  //   name: 'example',
  //   component: function (resolve) {
  //     require(['../views/example'], resolve) // 组件调用
  //   },
  //   meta: {
  //     title: '页面标题', // 该项为string时,会将微信顶栏的标题修改为设置值(必用)
  //     banShare: false, // 该项为true时,会粗暴地禁止掉所有的微信分享相关项目(慎用)
  //     setShare: { // 快速设置分享(入口页可能会失效),不允许在这里设置success(你看着办)
  //       title: '',
  //       desc: '',
  //       link: '',
  //       imgUrl: ''
  //     },
  //     hideMenu: [] // 隐藏某些菜单(慎用)
  //   }
  // },
  {
    path: '/loading',
    name: 'loading',
    component: function (resolve) {
      require(['../views/loading'], resolve)
    }
  },
  {
    path: '/phone',
    name: 'phone',
    component: function (resolve) {
      require(['../views/phone'], resolve)
    },
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/rule',
    name: 'rule',
    component: function (resolve) {
      require(['../views/rule'], resolve)
    },
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/sharePage',
    name: 'sharePage',
    component: function (resolve) {
      require(['../views/sharePage'], resolve)
    },
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/endPage',
    name: 'endPage',
    component: function (resolve) {
      require(['../views/endPage'], resolve)
    },
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/letter',
    name: 'letter',
    component: function (resolve) {
      require(['../views/letter'], resolve)
    },
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/home',
    name: 'home',
    component: function (resolve) {
      require(['../views/home'], resolve)
    },
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/poster',
    name: 'poster',
    component: function (resolve) {
      require(['../views/poster'], resolve)
    },
    meta: {
      requireAuth: true
    }
  }
]
